import { Component } from '@angular/core';

@Component({
  selector: 'palantir-content',
  standalone: true,
  imports: [],
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
})
export class PalantirContentComponent {}
